/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Pagination } from '../models/Pagination';
import { ResourceTag } from '../models/ResourceTag';

export class ListInventoryTagsResponse {
  'tags': Array<ResourceTag>;
  'pagination': Pagination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "tags",
      "baseName": "tags",
      "type": "Array<ResourceTag>",
      "format": ""
    },
    {
      "name": "pagination",
      "baseName": "pagination",
      "type": "Pagination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListInventoryTagsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

